import script from "./WReportComments.vue?vue&type=script&lang=ts&setup=true"
export * from "./WReportComments.vue?vue&type=script&lang=ts&setup=true"

import "./WReportComments.vue?vue&type=style&index=0&id=79cf3ed1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79cf3ed1"]])

export default __exports__